import React, { useContext, useEffect, useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "react-pro-sidebar";
import { matchPath, useHistory } from "react-router";
//style
import "react-pro-sidebar/dist/css/styles.css";
import { StyledFooterLink, StyledSidebar } from "./aside.style";
//assets
import { sidebarWidthMobile, sideItems } from "../navigator.constants";
//services
import { useTranslation } from "react-i18next";
import RoleManager from "../../../services/roleManagement";
// components
import { CustomPopoverTrigger } from "./components/CustomTriggerPopover";
import { popover } from "./components/popover";
import { sidebarWidth } from "../navigator.constants";
import { Link } from "react-router-dom";
import SystemContext from "../../../context/systemContext";
import browserStorage from "../../../services/storage";
import { useRequest } from "../../../hooks/useRequest/UseRequest";
import { SidebarHideShow } from "../../../assets/images/icons/SidebarHideShow";
import { IconButton } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../store/storeHooks";
import { closeSideBarFunc, openSideBarFunc } from "../../../store/reducers/SidebarSlice";
import { Code } from "@material-ui/icons";

export interface IClicked {
  name: string;
  url: string;
}
const Sidebar = ({ collapse, setCollapse }: any) => {
  //states
  const history = useHistory();
  const [showSettings, setShowSettings] = useState(false);
  const [hasAccess] = RoleManager();
  const [currentPath, setCurrentPath] = useState("");
  const { t } = useTranslation();
  const { orgSettings, roles } = useContext<any>(SystemContext);

  const { value } = useAppSelector((state) => state.sideBarData);
  const dispatch = useAppDispatch();


  const [clickedClient, data, status] = useRequest();

  const clicked = async (data: IClicked) => {
    try {
      await clickedClient.post("/analitics/sidebar", data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const url = window.location.href.split("/");
    url.splice(0, 3);
    setCurrentPath("/" + url.join("/"));
  }, [window.location.href]);


  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 640);
  window.addEventListener("resize", handleResize);
  
  return () => window.removeEventListener("resize", handleResize);
}, []);


  return (
    <StyledSidebar className={"open"}>
      <IconButton
        className={value ? "sidebar_arrow mt-2 bg-white" : "mt-2 left-1 sidebar_arrow active bg-white"}
        onClick={() =>
          dispatch(value ? closeSideBarFunc() : openSideBarFunc())
        }
      >
        <Code style={{ fontSize: "16px" }} />
      </IconButton>
      
      <ProSidebar
        collapsed={collapse}
        collapsedWidth={value ? sidebarWidth : sidebarWidthMobile} // sidebarWidthMobile
      // breakPoint="md"
      >
        <SidebarHeader></SidebarHeader>

        <SidebarContent>
          <Menu iconShape="circle">
            {sideItems
              ?.filter(
                (item: any) =>
                  orgSettings[item.showKey] ||
                  item.showKey === "settings" ||
                  (item.showKey === "monitoring" && roles?.isBoss)
              )
              ?.map((item: any) => {
                if (item.id === "settings") {
                  if (
                    item?.children?.find((ch: any) =>
                      ch.id.find((chii: any) => hasAccess(chii.id))
                    )
                  ) {
                    if (item.children) {
                      return (
                        <div
                          onMouseEnter={() => setShowSettings(true)}
                          onMouseLeave={() => setShowSettings(false)}
                          key={item.id}
                          className="custom-menu"
                        >
                          <OverlayTrigger
                            trigger={"click"}
                            placement="right-start"
                            show={showSettings}
                            overlay={popover(
                              "",
                              item?.children?.map(
                                (child: any, index: number) =>
                                  child?.id?.find((chi: any) =>
                                    hasAccess(chi?.id)
                                  ) && (
                                    <MenuItem
                                      key={index.toString()}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (
                                          history.location.pathname !==
                                          child.path
                                        ) {
                                          history.push(child.path);
                                          clicked({
                                            name: child.title,
                                            url: child.path,
                                          });
                                        }
                                      }}
                                      active={
                                        history.location.pathname ===
                                        child.path ||
                                        !!child?.child?.find(
                                          (path: string) =>
                                            matchPath(
                                              history.location.pathname,
                                              path
                                            )?.isExact
                                        )
                                      }
                                      className={`text-black`}
                                    >
                                      <li
                                        className={`list-item ${history.location.pathname ===
                                          child.path && "selected-menu"
                                          }`}
                                      >
                                        {t([`NAVIGATOR.${child.title}`])}
                                      </li>
                                    </MenuItem>
                                  )
                              )
                            )}
                            rootClose={true}
                          >
                            <div
                              onClick={() => { }}
                              className={`text-black custom-menu-item ${!!item.children?.find(
                                (chi: any) =>
                                  chi.path === history.location.pathname
                              ) ||
                                item.children?.find((i: any) =>
                                  i.child?.find(
                                    (ii: string) =>
                                      matchPath(history.location.pathname, ii)
                                        ?.isExact
                                  )
                                ) ||
                                showSettings
                                ? "openMenu"
                                : ""
                                }`}
                            >
                              <span className="icon">{item.icon}</span>
                              <span>
                                {collapse && t([`NAVIGATOR.${item.title}`])}
                              </span>
                              <div>
                                {!collapse && t([`NAVIGATOR.${item.title}`])}
                              </div>
                            </div>
                          </OverlayTrigger>
                        </div>
                      );
                    }
                  }
                } else {
                  if (
                    !item.multi &&
                    item?.children?.find((ch: any) => hasAccess(ch.id))
                  ) {
                    if (item.children) {
                      return (
                        <CustomPopoverTrigger
                          item={item}
                          history={history}
                          popover={popover}
                          hasAccess={hasAccess}
                          collapse={collapse}
                          key={item.id}
                          clicked={clicked}
                        />
                      );
                    }
                  } else {
                    if (
                      item.multi &&
                      item?.children?.find((ch: any) =>
                        ch.id?.find((v: any) => hasAccess(v))
                      )
                    ) {
                      return (
                        <CustomPopoverTrigger
                          item={item}
                          history={history}
                          popover={popover}
                          hasAccess={hasAccess}
                          collapse={collapse}
                          key={item.id}
                          clicked={clicked}
                        />
                      );
                    }
                  }
                }
                if (hasAccess(item.id))
                  return (
                    <div
                      key={item.id}
                      className="custom-menu"
                      onClick={(e) => {
                        e.preventDefault();
                        if (history.location.pathname !== item.path) {
                          history.push(item.path);
                          clicked({ name: item.title, url: item.path });
                        }
                      }}
                    >
                      <div
                        className={`text-black custom-menu-item ${(history.location.pathname.includes(item.path) ||
                          item?.child?.find(
                            (value: any) =>
                              matchPath(history.location.pathname, value)
                                ?.isExact
                          )) &&
                          "openMenu"
                          }`}
                      >
                        <span className="icon">{item.icon}</span>{" "}
                        {/* !here it is */}
                        <span>
                          {collapse && t([`NAVIGATOR.${item.title}`])}
                        </span>
                        <div>{!collapse && t([`NAVIGATOR.${item.title}`])}</div>
                      </div>
                    </div>
                  );
              })}
          </Menu>
        </SidebarContent>
        <SidebarFooter className={"py-3"} style={{ textAlign: "center" }}>
          <StyledFooterLink
            style={{ cursor: "pointer" }}
            href="https://t.me/edutizim"
            target="_blank"
          >
            <span>
              {t("NAVIGATOR.EDU_SYSTEM")}
              <div>{"© 2020"}</div>
            </span>
          </StyledFooterLink>
        </SidebarFooter>
      </ProSidebar>
     
    </StyledSidebar>
  );
};

export default Sidebar;
